/// <reference path="../../types/jwplayer.d.ts"/>
import JwPlayerPlugin from "./plugin";
function JwPlayerPluginFn() {
    if (!jwplayer)
        return;
    var Plugin = function (player, config, div) {
        var conf = player.getConfig();
        var plugin = new JwPlayerPlugin(jwplayer, conf.advertising, player, div);
        player.onReady(function () {
            // plugin.setup();
        });
        player.onPlay(function () {
            plugin.showStartLinearAd();
        });
        player.onPlaylistItem(function () {
            plugin.setup();
        });
        if (conf.advertising.debug)
            console.debug("Init JwPlayer Vast Plugin.");
    };
    var minPlayerVersion = "6.0";
    var pluginName = "vast";
    jwplayer("").registerPlugin(pluginName, minPlayerVersion, Plugin);
}
JwPlayerPluginFn();
export default JwPlayerPluginFn;
//# sourceMappingURL=index.js.map